import { useCallback } from 'react';
import { useAuthFetch } from '@cko/dashboard-shared';
import { QueryFunctionContext } from '@tanstack/react-query';

export enum MerchantTier {
  free = 'free',
  basic = 'basic',
  premium = 'premium',
}

export type SubNasMerchant = {
  entity_id: string;
  id: string;
  name: string;
};

export type SubAbcMerchant = {
  account_id: string;
  business_id: string;
  id: string;
  name: string;
};

export type SubMerchant = SubNasMerchant | SubAbcMerchant;

type ClientsResponseDisabled = {
  enabled: false;
};

export type ClientsResponseEnabled = {
  enabled: true;
  id: string;
  name: string;
  ml_score_enabled: boolean;
  read_only_restriction_enabled: boolean;
  tier: MerchantTier;
  merchant_id: string;
  children_entity_and_sub_merchant_ids: SubNasMerchant[];
};

export type ClientsResponse = ClientsResponseDisabled | ClientsResponseEnabled;

export const useGetPrismLinkAvailabilityFetcher = () => {
  const fetch = useAuthFetch();

  return useCallback(
    async ({ queryKey }: QueryFunctionContext) => {
      const [path] = queryKey as [string];

      const response = await fetch(path, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const profile: ClientsResponse = await response.json();
      return profile;
    },
    [fetch],
  );
};
